import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg, fileUrl } from "@/lib/api";
import useFetch from "@/lib/useFetch";
import { PageHeader, Loading, ErrorState, EmptyState } from "@/components/common";
import { brl, fmtDateTime, stageColor, plural } from "@/lib/format";
import { Contact, MapPin, Phone, Eye, ArrowRight } from "@/components/icons";
import { useState } from "react";

export default function Potenciais() {
  const navigate = useNavigate();
  const { data, loading, error, reload } = useFetch("/captacoes");

  const marcarVisto = async (cid) => {
    try { await api.patch(`/captacoes/${cid}/visto`); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  if (loading) return <Loading />;
  if (error) return <ErrorState onRetry={reload} />;
  const items = data.items || [];

  return (
    <div>
      <PageHeader title="Indicações do gestor" subtitle={`${plural(data.count, "prospect indicado", "prospects indicados")}${data.novas ? ` · ${plural(data.novas, "nova", "novas")}` : ""}`} />
      {items.length === 0 ? (
        <EmptyState icon={Contact} title="Nenhum prospect indicado" subtitle="Fotos de estabelecimentos enviadas pelo gestor aparecerão aqui." />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((c) => (
            <div key={c.id} className={`bg-card rounded-2xl border overflow-hidden shadow-[0_4px_20px_rgb(0,0,0,0.03)] ${c.visto ? "border-black/5" : "border-brand/40 ring-1 ring-brand/20"}`} data-testid={`captacao-${c.id}`}>
              <PotencialFoto fotoId={c.foto_id} alt={c.nome} />
              <div className="p-5">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <div className="font-semibold text-navy">{c.nome}</div>
                    <div className="text-xs text-muted-foreground">Enviado por {c.enviado_por_nome} · {fmtDateTime(c.created_at)}</div>
                  </div>
                  {!c.visto && <span className="text-[10px] font-bold uppercase bg-brand text-white px-2 py-0.5 rounded-full">Novo</span>}
                </div>
                <div className="mt-3 space-y-1 text-sm text-slate-600">
                  {c.telefone && <div className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" />{c.telefone}</div>}
                  {c.endereco && <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{c.endereco}</div>}
                  {c.observacao && <div className="text-xs italic text-muted-foreground">{`"${c.observacao}"`}</div>}
                </div>
                <div className="flex items-center justify-between mt-4">
                  {c.stage && <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${stageColor(c.stage)}`}>{c.stage}</span>}
                  <div className="flex gap-2 ml-auto">
                    {!c.visto && <button onClick={() => marcarVisto(c.id)} data-testid={`visto-${c.id}`} className="flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-navy px-2 py-1"><Eye className="w-3.5 h-3.5" /> Marcar visto</button>}
                    {c.deal_id && <button onClick={() => navigate(`/deal/${c.deal_id}`)} className="flex items-center gap-1.5 text-xs font-semibold text-brand hover:text-brand-hover px-2 py-1">Abrir <ArrowRight className="w-3.5 h-3.5" /></button>}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Área de foto que some se não há foto OU se o carregamento falhou.
function PotencialFoto({ fotoId, alt }) {
  const [erro, setErro] = useState(false);
  if (!fotoId || erro) return null;
  return (
    <div className="aspect-video bg-slate-100">
      <img src={fileUrl(fotoId)} alt={alt} className="w-full h-full object-cover" loading="lazy" onError={() => setErro(true)} />
    </div>
  );
}
